import React from 'react';

export default function Footer() {
  return (
    <footer>
      <p>
        Percentage values may differ from local government sources as the total
        population is used as the denominator for percentage calculations.
        <br />
        Source:{' '}
        <a
          href="https://ourworldindata.org/covid-vaccinations"
          target="_blank"
          rel="noreferrer"
        >
          Our World in Data
        </a>
      </p>
    </footer>
  );
}
